module.exports = __webpack_public_path__ + "img/bg.d187803b.png";